import { render } from "./addNotice.vue?vue&type=template&id=f8f639a0&scoped=true"
import script from "./addNotice.vue?vue&type=script&lang=js"
export * from "./addNotice.vue?vue&type=script&lang=js"

import "./addNotice.vue?vue&type=style&index=0&id=f8f639a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f8f639a0"

export default script